import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PositionsComponent } from './positions/positions.component';
import { PositionsDetailComponent } from './positions-detail/positions-detail.component';
import { TableModule } from '../../components/table/table.module';
import { MatIconModule } from '@angular/material/icon';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { NumberFormatDirective } from '../../utils/number-format.directive';


@NgModule({
  declarations: [
    PositionsComponent,
    PositionsDetailComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    TableModule,
    MatAccordion,
    MatExpansionModule,
    MatFormFieldModule,

    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTableModule,
    NumberFormatDirective,
  ]
})
export class PositionsModule { }
